module.exports = __webpack_public_path__ + "img/vizio2-cover-1.3f408729.jpg";